export interface FundRuleConditionInterface {
  parameter_name?: string;
  parameter_comparator?: string;
  parameter_value?: string;
  rule_condition_type?: string;
}

export class FundRuleCondition {
  fund_rule_uuid!: string;
  parameter_name!: string;
  parameter_comparator!: string;
  parameter_value!: string;
  rule_condition_type!: string;

  constructor(data: any) {
    this.fund_rule_uuid = data.fund_rule_uuid;
    this.parameter_name = data.parameter_name;
    this.parameter_comparator = data.parameter_comparator;
    this.parameter_value = data.parameter_value;
    this.rule_condition_type = data.rule_condition_type;
  }
}
